import { Form, InputRef } from 'antd';
import PercentInput from 'components/CurrencyInputPrecision/PercentInput';
import Modal from 'components/Modal';
import { NumberPadIntV2 } from 'components/NumberKeyBoard/Currency/NumberPadV2';
import React, { forwardRef, useImperativeHandle, useRef, useState } from 'react';
import styled from 'styled-components';

type Ref = {
  open: () => void;
};

type Props = {
  onSubmit: (amount: number) => void;
};

export const useModalNumberCustomersCustomRef = () => useRef<Ref>(null);

const ModalNumberCustomersCustom = forwardRef<Ref, Props>(({ onSubmit }, ref) => {
  const [visible, setVisible] = useState(false);
  const inputDiscountValueRef = useRef<InputRef>(null);
  const [form] = Form.useForm();
  const onClose = () => setVisible(false);
  const handleSubmit = (values: any) => {
    onSubmit(values.amount);
    onClose();
  };
  useImperativeHandle(ref, () => ({
    open: () => {
      form.resetFields();
      setVisible(true);
    },
  }));
  return (
    <Modal noneBodyStyle width={900} visible={visible} onSubmit={() => form.submit()} modalTitle='NUMBER CUSTOMERS' v2 onClose={onClose}>
      <Container form={form} onFinish={handleSubmit}>
        <Form.Item name={'amount'} noStyle>
          <PercentInput
            height={64}
            inputRef={inputDiscountValueRef}
            inputMode='none' className='gift-card-number-input fs-big fs-medium' size='small'
            onChangeDebounce={() => form.validateFields(['amount'])}
            maxValue={1000}
            nonSymbol
          />
        </Form.Item>
        <Form.Item noStyle name={'amount'}>
          <NumberPadIntV2
            controlRef={inputDiscountValueRef}
            max={1000}
            onChange={() => form.validateFields(['amount'])}
          />
        </Form.Item>
      </Container>
    </Modal>
  );
});
ModalNumberCustomersCustom.displayName = 'ModalNumberCustomersCustom';
export { ModalNumberCustomersCustom };

const Container = styled(Form)`
padding: 16px 0;
.gift-card-number-input {
  color: #1D2129;
  text-align: center;
  font-family: Poppins;
  align-self: stretch;
  font-size: 30px;
  height: unset;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  border: none;
  outline: none;
  box-shadow: none;
  &.fs-big {
    font-size: 55px;
  }
  &.fs-medium {
    font-size: 45px;
  }
}
`;